import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { CONTAINER_ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { LoadablePaint } from '@confluence/loadable';
import { shouldShowMobileWeb } from '@confluence/mobile-detection';

import SpaceBase from '../../SpaceBase/index.js';

const ArchivedPagesListContainer = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ArchivedPagesListContainer" */ '@confluence/archived-pages-list/entry-points/ArchivedPagesListContainer.ts'
			)
		).ArchivedPagesListContainer,
});

export const SpaceArchivedPagesRoute: {
	({ params: { spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS({ name, params: { spaceKey } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				id: string;
			};
			pageState: {
				routeName: string;
				spaceKey: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
			enableNavigation: boolean;
		};
	};
} = ({ params: { spaceKey } }: RouteMatch): React.JSX.Element => {
	return (
		<SpaceBase>
			<ArchivedPagesListContainer spaceKey={spaceKey} />
		</SpaceBase>
	);
};

SpaceArchivedPagesRoute.NAVIGATION_PARAMS = ({
	name,
	params: { spaceKey },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			id: string;
		};
		pageState: {
			routeName: string;
			spaceKey: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: string;
		enableNavigation: boolean;
	};
} => {
	const isMobile = shouldShowMobileWeb();
	return {
		Screen: {
			screenEvent: {
				name: 'spaceArchivedPages',
				id: spaceKey,
			},
			pageState: {
				routeName: name,
				spaceKey,
			},
		},
		MainLayout: {
			navView: CONTAINER_ADMIN_HOME_ID,
			spaceKey,
			enableNavigation: !isMobile,
		},
	};
};
